<template>
  <div class="car-vehicle-details">
    <div class="car-list">
      <span class="car-list-label" data-js="booking-vehicle">
        {{vehicle.vehicleTypeName}}
      </span>
    </div>

    <spinner v-if="loading" class="car-spinner car-content-spinner" />

    <div v-else-if="vehicle.selectedEquipments && vehicle.selectedEquipments.length && equipments.length"
       class="car-list"
       data-js="booking-vehicle__toggle-details">
      <span class="car-list-label">
        {{$t('offer.vehicleDetail.equipments')}}
      </span>
      <div class="car-items">
        <div class="car-item" v-for="e in equipments" :key="e.id">
          <span class="car-text">{{ e | optionTranslate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vehicleService from '@/services/vehicleService';
import Spinner from 'vue-simple-spinner';

export default {
  name: 'VehicleDetails',
  data() {
    return {
      equipments: [],
      loading: false
    }
  },
  props: {
    vehicle: {
      default: {}
    }
  },
  watch: {
    vehicle: {
      handler: function() {
        let dimensionValues = [];
        this.loading = true;
        this.vehicle.vehicleTypeEquipmentList.forEach(e => {
          let match = this.vehicle.dimensionValues.find(v => v.includes(e.equipmentCode));
          if (match) dimensionValues.push(match);
        });

        let promises = [];

        dimensionValues.forEach(v => { promises.push(vehicleService.getDimensionValues({ externalIds: v })); });

        return Promise.all(promises)
          .then(res => { this.$set(this, 'equipments', res.map(r => r.data[0])) })
          .finally(() => { this.loading = false; })
      },
      immediate: true
    }
  },
  components: { Spinner }
}
</script>
